/** Cookie primitives for the modules that own a cookie. Apps reach a cookie only through its owning module. */

/** One `Set-Cookie` value, hand-built because Next's `response.cookies` keys by
 *  name and so cannot send two `_fbp` expiries in one response. No `domain`
 *  means host-only. */
export function setCookie(
  name: string,
  value: string,
  attrs: { domain?: string; secure: boolean; maxAge: number },
): string {
  return [
    `${name}=${value}`,
    attrs.domain ? `Domain=${attrs.domain}` : null,
    "Path=/",
    `Max-Age=${attrs.maxAge}`,
    "SameSite=Lax",
    // Browsers drop a Secure cookie over `next dev`'s http://127.0.0.1.
    attrs.secure ? "Secure" : null,
  ]
    .filter(Boolean)
    .join("; ");
}

/** The first exact-name match's value, trimmed, or null. */
export function readCookie(
  cookieString: string | null | undefined,
  name: string,
): string | null {
  if (!cookieString) return null;
  for (const pair of cookieString.split(";")) {
    const eq = pair.indexOf("=");
    if (eq !== -1 && pair.slice(0, eq).trim() === name) {
      return pair.slice(eq + 1).trim();
    }
  }
  return null;
}

const SHARED_DOMAIN = "medceptor.com";

/** `.medceptor.com` on medceptor hosts, else undefined (host-only): a browser
 *  silently rejects a Domain that does not cover the current host, which would
 *  make a cookie do nothing on a preview or 127.0.0.1. */
export function sharedCookieDomain(hostname: string): string | undefined {
  const host = hostname.toLowerCase().replace(/\.$/, "");
  return host === SHARED_DOMAIN || host.endsWith(`.${SHARED_DOMAIN}`)
    ? `.${SHARED_DOMAIN}`
    : undefined;
}
